import { render, staticRenderFns } from "./IconSvgRefresh.vue?vue&type=template&id=26e5630e&scoped=true&"
import script from "./IconSvgRefresh.vue?vue&type=script&lang=js&"
export * from "./IconSvgRefresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e5630e",
  null
  
)

export default component.exports